// src/components/Providers.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AppRoutes from './routes';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as ThemeProviderStyled } from 'styled-components';
import { getTheme } from '../config/theme';
import '../App.css';
import { ReactQueryDevtools } from 'react-query/devtools';
import { getProfile } from '../api';
import { ParallaxProvider } from 'react-scroll-parallax';
import { useProfile } from '../context';
import FeedbackComponent from 'components/organisms/feedback/view';
import { GoogleOAuthProvider } from '@react-oauth/google';
import CookieConsent from 'components/organisms/cookieConsent/view';
import ReactGA from "react-ga4";
import { configureToken } from 'api';

// The analytics component that will wrap the AppRoutes
const RouteTracker = () => {
  const location = useLocation();
  const { profile } = useProfile();
  const isAuthenticated = localStorage.getItem('token') && profile;
  
  useEffect(() => {
    // Send pageview with current path
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
    //console.log("Page view tracked:", location.pathname + location.search);
  }, [location]);
  
  return (
    <>
      <AppRoutes profile={profile} />
      {isAuthenticated && <FeedbackComponent />}
      <CookieConsent />
    </>
  );
};

const Providers = () => {
  const [theme, ] = useState(getTheme(null));
  const [, setConfigLoaded] = useState(false);
  const { profile, setProfile } = useProfile();
  
  const fetchProfile = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }
    
    // Ensure token is configured before making the request
    configureToken(token);

    try {
      const localData = await getProfile();
      setProfile(localData);
    } catch (error) {
      console.error('Failed to fetch profile', error);
    }
  };
  
  useEffect(() => {
    const loggedIn = localStorage.getItem('token');
    if (loggedIn) {
      fetchProfile().then(() => setConfigLoaded(true));
    } else {
      setConfigLoaded(true);
    }
  }, [setProfile]);
  
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
  
  return (
    <>
      <GoogleOAuthProvider clientId={googleClientId}>
        <ParallaxProvider>
          <ThemeProviderStyled theme={theme}>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SnackbarProvider maxSnack={3}>
                  <Router>
                    <Routes>
                      {/* This single Route wraps all your app routes with analytics tracking */}
                      <Route path="*" element={<RouteTracker />} />
                    </Routes>
                  </Router>
                </SnackbarProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </ThemeProviderStyled>
        </ParallaxProvider>
      </GoogleOAuthProvider>
      {/* Only show React Query Devtools in development */}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </>
  );
};

export default Providers;